module.exports = __webpack_public_path__ + "static/media/hire.c82e0045.svg";